import React from 'react';
import { motion } from 'framer-motion';
export function WhoIsForSection() {
  return <section className="py-16 md:py-24 px-5 md:px-8" data-id="element-160">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-161">
        {/* Who it is for */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#1a1f3a] p-8 rounded-2xl border-t-4 border-green-500 shadow-lg" data-id="element-162">
          <h3 className="text-2xl font-serif font-bold text-white mb-6 flex items-center gap-3" data-id="element-163">
            <span className="text-green-500 text-3xl" data-id="element-164">✓</span> Para quién ES
            esto:
          </h3>
          <ul className="space-y-4" data-id="element-165">
            {['Personas que sufren de tinnitus agudo, siseo o rugido constante.', 'Quienes tienen dificultades para conciliar el sueño debido al silencio de la noche.', 'Personas que sienten ansiedad o pánico cuando el zumbido sube de volumen.', "Aquellos que están cansados de que les digan 'tienes que aprender a vivir con ello' sin darles herramientas reales."].map((text, i) => <li key={i} className="flex gap-3 text-gray-300" data-id="element-166">
                <span className="text-green-500 mt-1" data-id="element-167">•</span>
                <span data-id="element-168">{text}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Who it is NOT for */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#1a1f3a] p-8 rounded-2xl border-t-4 border-red-500 shadow-lg" data-id="element-169">
          <h3 className="text-2xl font-serif font-bold text-white mb-6 flex items-center gap-3" data-id="element-170">
            <span className="text-red-500 text-3xl" data-id="element-171">✕</span> Para quién NO es:
          </h3>
          <ul className="space-y-4" data-id="element-172">
            {['Personas con pérdida auditiva súbita o dolor agudo (deben ver a un médico de inmediato).', "Quienes buscan una 'pastilla mágica' que elimine el sonido sin cambiar sus hábitos nocturnos.", 'Tinnitus causado por infecciones activas que requieren tratamiento antibiótico.'].map((text, i) => <li key={i} className="flex gap-3 text-gray-300" data-id="element-173">
                <span className="text-red-500 mt-1" data-id="element-174">•</span>
                <span data-id="element-175">{text}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}